'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const universal_color = require('../../style/universal.color.js');
const table_types = require('./table.types.js');
const tableRow = require('./TableRow/table-row.js');
const tableHeader = require('./TableHeader/table-header.js');
const tableFooter = require('./TableFooter/table-footer.js');
const table_style = require('./table.style.js');

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var mlbGrey1 = universal_color.mlbGrey1,
    mlbGrey5 = universal_color.mlbGrey5; // A unique counter to give each table a unique index

var tableCounter = 0; // Create the array of table rows to be rendered

var createTableRows = function createTableRows(columnRowData, tableUniqueIndex, props, dark, highlightedCells, highlightColor, tableRowHandlers, selectedRowIndex) {
  var tbody = props.tbody,
      customCells = props.customCells,
      highlightHead = props.highlightHead,
      columnsState = props.columnsState,
      columnSortIndex = props.columnSortIndex,
      highlightSortedColumn = props.highlightSortedColumn;
  return tbody.map(function (row, i) {
    return /*#__PURE__*/React__default.createElement(tableRow, {
      tableIndex: tableUniqueIndex,
      data: row,
      columnData: columnRowData,
      rowIndex: i,
      type: table_types.CellTypes.BODY,
      key: "row-".concat(i),
      customCells: customCells,
      dark: dark,
      highlightedCells: highlightedCells,
      highlightHead: highlightHead,
      firstRow: i === 0,
      lastRow: i === tbody.length - 1,
      columnsState: columnsState,
      columnSortIndex: columnSortIndex,
      highlightSortedColumn: highlightSortedColumn,
      highlightColor: highlightColor,
      tableRowHandlers: tableRowHandlers,
      selectedRowIndex: selectedRowIndex
    });
  });
};

var Table = function Table(props) {
  var thead = props.thead,
      tbody = props.tbody,
      tfoot = props.tfoot,
      _props$width = props.width,
      width = _props$width === void 0 ? '100%' : _props$width,
      maxWidth = props.maxWidth,
      _props$tableFixed = props.tableFixed,
      tableFixed = _props$tableFixed === void 0 ? false : _props$tableFixed,
      customCells = props.customCells,
      _props$startRight = props.startRight,
      startRight = _props$startRight === void 0 ? false : _props$startRight,
      _props$bodyTdPadding = props.bodyTdPadding,
      bodyTdPadding = _props$bodyTdPadding === void 0 ? '12px 6px' : _props$bodyTdPadding,
      _props$bodyThPadding = props.bodyThPadding,
      bodyThPadding = _props$bodyThPadding === void 0 ? '12px' : _props$bodyThPadding,
      _props$headThPadding = props.headThPadding,
      headThPadding = _props$headThPadding === void 0 ? '6px' : _props$headThPadding,
      _props$hideDividers = props.hideDividers,
      hideDividers = _props$hideDividers === void 0 ? false : _props$hideDividers,
      _props$highlightedCel = props.highlightedCells,
      highlightedCells = _props$highlightedCel === void 0 ? [] : _props$highlightedCel,
      highlightHead = props.highlightHead,
      headerHandlers = props.headerHandlers,
      columnsState = props.columnsState,
      columnSortIndex = props.columnSortIndex,
      highlightSortedColumn = props.highlightSortedColumn,
      _props$hoverRowHighli = props.hoverRowHighlight,
      hoverRowHighlight = _props$hoverRowHighli === void 0 ? false : _props$hoverRowHighli,
      cellHighlightColor = props.cellHighlightColor,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? {} : _props$theme,
      className = props.className,
      tableRowHandlers = props.tableRowHandlers,
      selectedRowIndex = props.selectedRowIndex;
  var paddingConfig = {
    bodyTdPadding: bodyTdPadding,
    bodyThPadding: bodyThPadding,
    headThPadding: headThPadding
  }; // Discover if we're using the dark theme

  var _theme$dark = theme.dark,
      dark = _theme$dark === void 0 ? false : _theme$dark;
  var highlightColor = cellHighlightColor || (dark ? mlbGrey5 : mlbGrey1); // Create a reference to the div wrapper so we can set the scroll position

  var divRef = React.useRef(null); // Set the unique table index for this instance

  var _useState = React.useState(tableCounter++),
      _useState2 = _slicedToArray(_useState, 1),
      tableUniqueIndex = _useState2[0]; // If startRight prop is true, start the scroll to the right side


  React.useEffect(function () {
    if (startRight && !!divRef && !!divRef.current) {
      divRef.current.scrollLeft = divRef.current.scrollWidth;
    }
  }); // Create a table footer if data is passed

  var tableFooter$1 = tfoot ? /*#__PURE__*/React__default.createElement(tableFooter, {
    type: table_types.CellTypes.FOOTER,
    rowIndex: tbody.length,
    tableIndex: tableUniqueIndex,
    columnData: thead,
    data: tfoot,
    dark: dark,
    columnsState: columnsState,
    columnSortIndex: columnSortIndex
  }) : null;
  var lastColIndex = thead.length - 1; // Retrieving the first and last cols, whether they be stand-alone or the first in a group.
  // Because of the magic of TypeScript, we have to cast it first as a group to check
  // if it has a group-only property 'groupColumns'. We then retrieve the necessary obj.
  // Afterwards, we use it for checking pinning and fixed widths for the pinned 
  // absolute positioning and parent margin placement

  var firstCol = !thead[0].groupColumns ? thead[0] : thead[0].groupColumns[0];
  var lastCol = !thead[lastColIndex].groupColumns ? thead[lastColIndex] : thead[lastColIndex].groupColumns[thead[lastColIndex].groupColumns.length - 1];
  return /*#__PURE__*/React__default.createElement(table_style.TableContainer, {
    containerWidth: width,
    containerMaxWidth: maxWidth
  }, /*#__PURE__*/React__default.createElement(table_style.TableScroller, {
    divWidth: '100%',
    hideDividers: hideDividers,
    ref: divRef,
    dark: dark,
    leftPadding: firstCol.pinned && (firstCol.fixedWidth || '100px') || '0px',
    rightPadding: lastCol.pinned && (lastCol.fixedWidth || '100px') || '0px'
  }, /*#__PURE__*/React__default.createElement(table_style.StyledTable, {
    tableFixed: tableFixed,
    dark: dark,
    paddingConfig: paddingConfig,
    hideDividers: hideDividers,
    tfootExists: !!tableFooter$1,
    hoverRowHighlight: hoverRowHighlight,
    highlightColor: highlightColor,
    className: className
  }, /*#__PURE__*/React__default.createElement(tableHeader, {
    tableIndex: tableUniqueIndex,
    columnData: thead,
    customCells: customCells,
    dark: dark,
    highlightHead: highlightHead,
    headerHandlers: headerHandlers,
    columnsState: columnsState,
    columnSortIndex: columnSortIndex,
    highlightSortedColumn: highlightSortedColumn,
    highlightColor: highlightColor
  }), /*#__PURE__*/React__default.createElement("tbody", null, createTableRows(thead, tableUniqueIndex, props, dark, highlightedCells, highlightColor, tableRowHandlers, selectedRowIndex)), tableFooter$1)));
};

const Table$1 = styled.withTheme(Table);

module.exports = Table$1;
